const R2_PUBLIC_URL = (import.meta.env.VITE_R2_PUBLIC_URL as string | undefined)?.replace(/\/$/, '') ?? '';

/** Public R2 URL of a stored trip photo. Fine for <img>; canvases need the
 *  same-origin bytes from `GET /trips/:id/share-background` instead. */
export function tripPhotoUrl(filename: string): string {
  return `${R2_PUBLIC_URL}/${filename}`;
}
